// Fetch list

export const FETCH = 'blockedIps.FETCH'
export const FETCH_STARTED = 'blockedIps.FETCH_STARTED'
export const FETCH_FULFILLED = 'blockedIps.FETCH_FULFILLED'
export const FETCH_REJECTED = 'blockedIps.FETCH_REJECTED'
export const FETCH_CANCELLED = 'blockedIps.FETCH_CANCELLED'

export const SORTING_CHANGED = 'blockedIps.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'blockedIps.FETCH_ONE'
export const FETCH_ONE_STARTED = 'blockedIps.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'blockedIps.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'blockedIps.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'blockedIps.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'blockedIps.SAVE'
export const SAVE_STARTED = 'blockedIps.SAVE_STARTED'
export const SAVE_FULFILLED = 'blockedIps.SAVE_FULFILLED'
export const SAVE_REJECTED = 'blockedIps.SAVE_REJECTED'
export const SAVE_CANCELLED = 'blockedIps.SAVE_CANCELLED'

// Delete

export const DELETE = 'blockedIps.DELETE'
export const DELETE_STARTED = 'blockedIps.DELETE_STARTED'
export const DELETE_FULFILLED = 'blockedIps.DELETE_FULFILLED'
export const DELETE_REJECTED = 'blockedIps.DELETE_REJECTED'
export const DELETE_CANCELLED = 'blockedIps.DELETE_CANCELLED'

// Export

export const EXPORT = 'blockedIps.EXPORT'
export const EXPORT_FULFILLED = 'blockedIps.EXPORT_FULFILLED'
